import type { BlockSimpleCardCta } from 'types/block-simple-card-cta';
import React from 'react';
import { Wrap, Button, Paragraph, Card } from '@leafwell/components';
import Figure from './figure';
import HeadingBody from './heading-body';
import StateSelect from './state-select';

const SimpleCardCta: React.FC<
  Omit<BlockSimpleCardCta, 'acfFcLayout'> & {
    removeHorizontalPadding?: boolean;
    reduceHorizontalPadding?: boolean;
  }
> = ({
  layout = 'primary',
  label,
  title,
  description,
  button,
  image,
  stateSelect = false,
  removeHorizontalPadding = false,
  reduceHorizontalPadding = false,
}) => {
  const hasDescription = description?.length > 0;
  const isPrimary = layout === 'primary';
  return (
    <Wrap
      id=""
      className={[
        '!gap-y-3 lg:gap-x-4',
        isPrimary ? 'lg:grid-cols-[1.5fr_1fr]' : 'lg:grid-cols-[1fr_1.5fr]',
        removeHorizontalPadding ? '!px-0' : '',
        reduceHorizontalPadding ? '!px-0 lg:!px-5' : '',
      ].join(' ')}
    >
      {image && (
        <Figure
          {...image}
          className="rounded-2xl"
          classNameImage={isPrimary ? '' : 'object-cover	min-h-full'}
          priority={isPrimary ? false : true}
        />
      )}
      <Card rounded={true} className="!p-4 lg:!p-6">
        <div
          className={[
            'grid gap-3',
            hasDescription ? 'lg:grid-cols-[1.5fr_1fr] gap-x-16' : '',
          ].join(' ')}
        >
          <span className="grid gap-3">
            {label?.length > 0 && <Paragraph>{label}</Paragraph>}
            {title?.length > 0 && (
              <HeadingBody
                level="2"
                tagName="h2"
                title={title}
                className="font-semibold"
              />
            )}
            {hasDescription && (
              <Paragraph
                className={['text-lg', stateSelect ? 'lg:self-end' : ''].join(
                  ' ',
                )}
              >
                {description}
              </Paragraph>
            )}
          </span>
          <span
            className={[
              'self-end',
              hasDescription ? 'lg:justify-self-end' : '',
            ].join(' ')}
          >
            {stateSelect && <StateSelect inlineButton={false} />}
            {button && !stateSelect && (
              <Button
                href={button.url}
                label={button.title}
                rounded={true}
                target={button.target}
                variant="secondary"
                className="w-fit h-fit"
              />
            )}
          </span>
        </div>
      </Card>
    </Wrap>
  );
};

export default SimpleCardCta;
